import styled from '@emotion/styled'

const avatarDimensionSwitch = (
  amount: 1 | 3 | 7,
  personAmount: number,
  windowWidth: number
) => {
  switch (amount) {
    case 1:
      return '25px'
    case 3:
      return '20px'
    case 7:
      return personAmount > 5 && windowWidth < 1300 ? '15px' : '20px'
    default:
      return '20px'
  }
}

const headerDisplaySwitch = (
  amount: 1 | 3 | 7,
  personAmount: number,
  windowWidth: number
) => {
  switch (true) {
    case personAmount > 3:
      if (amount === 7 || (amount === 3 && windowWidth < 1024)) {
        return 'none'
      }
      if (amount === 3 && windowWidth < 400) {
        return 'none'
      }
      return 'none'
    case personAmount > 4 && amount === 3:
      return 'none'
    default:
      return 'auto'
  }
}

export const PersonHeadersWrapper = styled.div`
  border: 1px solid #c9c9c9;
  color: black;
  display: flex;
  overflow: hidden;
  border-right: 0;
  border-left: 0;
`

export const PersonHeadersContainer = styled.div<{ cabin: boolean }>`
  -o-text-overflow: ellipsis;
  background: ${({ cabin }) => (cabin ? '#fa8072' : '#ffffff')};
  display: flex;
  min-height: 32px;
  overflow: hidden;
  padding: 0.6em 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`

export const PersonHeaderAvatar = styled.img<{
  amountOfDays: 1 | 3 | 7
  persons: number
  windowWidth: number
}>`
  border-radius: 50px;
  display: block;
  height: ${({ amountOfDays, persons, windowWidth }) =>
    avatarDimensionSwitch(amountOfDays, persons, windowWidth)};
  margin: 6px 18px;
  min-width: 20px;
  overflow: hidden;
  width: ${({ amountOfDays, persons, windowWidth }) =>
    avatarDimensionSwitch(amountOfDays, persons, windowWidth)};
`

export const PersonHeader = styled.div<{
  amountOfDays: 1 | 3 | 7
  persons: number
  windowWidth: number
  isBorder: boolean
}>`
  border-right: ${({ isBorder }) => (isBorder ? '1px solid #c9c9c9' : 0)};
  display: ${({ persons, amountOfDays, windowWidth }) =>
    headerDisplaySwitch(amountOfDays, persons, windowWidth)};
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
`

export const PersonHeaderText = styled.p<{
  windowWidth: number
  persons: number
}>`
  color: #3c4043;
  font-family: Roboto, sans-serif;
  font-size: ${({ persons, windowWidth }) =>
    persons > 3 && windowWidth < 580 ? '12px' : '15px'};
  font-weight: 500;
  letter-spacing: 0.25px;
  line-height: 34px;
  margin: 2px 0;
  overflow: hidden;
  text-align: initial;
  text-overflow: ellipsis;
  text-transform: none;
`
